const createQuery = () => `
  ... on ArticleLayoutRelatedContentWidget {
    relatedContent {
      _id
      headline
      eventId
      eventBaseSlug
      eventArticleCategoryKey
      fullUrlPath
      category
    }
  }
`
export default createQuery
